import { render } from "./AccessRequestModal.vue?vue&type=template&id=556d806c&scoped=true"
import script from "./AccessRequestModal.vue?vue&type=script&lang=js"
export * from "./AccessRequestModal.vue?vue&type=script&lang=js"

import "./AccessRequestModal.vue?vue&type=style&index=0&id=556d806c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556d806c"]])

export default __exports__